import { render, staticRenderFns } from "./TermsOfServiceModal.vue?vue&type=template&id=54e35cd6&scoped=true"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceModal.vue?vue&type=style&index=0&id=54e35cd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e35cd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e35cd6')) {
      api.createRecord('54e35cd6', component.options)
    } else {
      api.reload('54e35cd6', component.options)
    }
    module.hot.accept("./TermsOfServiceModal.vue?vue&type=template&id=54e35cd6&scoped=true", function () {
      api.rerender('54e35cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TermsOfServiceModal.vue"
export default component.exports